import coreModule from 'app/core/core_module';

export function react2AngularDirective(name: string, component: any, options: any) {

  coreModule.directive(name, ['reactDirective', reactDirective => {
    return reactDirective(component, options);
  }]);

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./public/app/core/utils/react2angular.ts